import React, { Component } from 'react'
import * as CONSTANTS from 'app/modules/rules/constants'
import { Button, Select, Icon, Input } from '@driftt/tide-core-legacy'
import { update, remove } from 'ramda'

import './style.styl'

const typeOptions = Object.keys(CONSTANTS.URL_FILTER_TYPES).map((type) => ({ value: CONSTANTS.URL_FILTER_TYPES[type], label: CONSTANTS.URL_FILTER_TYPE_LABELS[type] }))
const operatorOptions = Object.keys(CONSTANTS.URL_FILTER_OPERATORS).map((type) => ({ value: CONSTANTS.URL_FILTER_OPERATORS[type], label: CONSTANTS.URL_FILTER_OPERATOR_LABELS[type] }))

class UrlFilter extends Component {

  constructor(props) {
    super(props)

    this.state = {
      fieldType: props.activeFilter.field,
      operatorType: props.activeFilter.operator,
      urlValue: props.activeFilter.value
    }
  }

  onTypeSelect = (type) => {
    this.props.updateModel(type.value)
    this.setState({ fieldType: type.value, urlValue: ['']}, this.updateParent)
  }

  onOperatorSelect = (type) => {
    this.setState({ operatorType: type.value }, this.updateParent)
  }

  updateParent = () => {
    const isValid = !!this.state.urlValue[0]
    this.props.setPageValidity(isValid)
    if (isValid) {
      this.props.setActiveFilter({
        field: this.state.fieldType,
        operator: this.state.operatorType,
        value: this.state.urlValue
      })
    }
  }

  updateUrlValue = (event, index) => {
    event.persist()
    this.setState((prevState) => ({ urlValue: update(index, event.target.value, prevState.urlValue) })
    , this.updateParent)
  }

  renderTypeSelect = () => (<Select options={typeOptions} onChange={this.onTypeSelect} value={this.state.fieldType} searchable={false} clearable={false}/>)
  renderOperatorType = () => (<Select options={operatorOptions} onChange={this.onOperatorSelect} value={this.state.operatorType} searchable={false} clearable={false} />)
  
  renderTypeComponent = (entry, index) => {
    const { URL_PATH, URL_HOST, URL_QUERY } = CONSTANTS.URL_FILTER_TYPES
    const components = {
      [URL_PATH] : this.renderPathInput,
      [URL_HOST] : this.renderHostInput,
      [URL_QUERY]: this.renderQueryInput
    }

    return components[this.state.fieldType](entry, index)
  }

  parseQueryParamName = (entry) => (entry.split('=')[0] || '')
  parseQueryParamValue = (entry) => (entry.split('=')[1] || '')

  updateQueryParamName = (event, index) => {
    event.persist()
    const updatedEntry = [event.target.value, this.parseQueryParamValue(this.state.urlValue[index])].join('=')
    this.setState((prevState) => ({ urlValue: update(index, updatedEntry, prevState.urlValue) }))
  }
  
  updateQueryParamValue = (event, index) => {
    event.persist()
    const updatedEntry = [this.parseQueryParamName(this.state.urlValue[index]), event.target.value].join('=')
    this.setState((prevState) => ({ urlValue: update(index, updatedEntry, prevState.urlValue) }))
  } 

  renderQueryInput = (entry, index) => {
    return (
      <div className="rule-url-query-filter">
        <div className="rule-url-query-input">
          <Input type="text" value={this.parseQueryParamName(entry)} onChange={(event) => this.updateQueryParamName(event, index)} placeholder="query param" />
        </div>

        <span className="equals-icon">=</span>

        <div className="rule-url-query-input">
          <Input type="text" value={this.parseQueryParamValue(entry)} onChange={(event) => this.updateQueryParamValue(event, index)} placeholder="value" />
        </div>
      </div>
    )
  }

  renderHostInput = (entry, index) => (<Input type="text" value={entry} placeholder="example: app.drift.com" onChange={(event) => this.updateUrlValue(event, index)}/>)
  renderPathInput = (entry, index) => (<Input type="text" value={entry} placeholder="example: /pricing" onChange={(event) => this.updateUrlValue(event, index)}/>)

  addEntryToUrlValue = () => this.setState((prevState) => ({ urlValue: [...prevState.urlValue, '']}), this.updateParent)
  removeEntryFromUrlValue = (index) => this.setState((prevState) => ({ urlValue: remove(index, 1, prevState.urlValue) }), this.updateParent)

  renderMultiEntryInputs = () => {
    const entries = this.state.urlValue.map((entry, index) => (
        <div className="url-filter-multi-entry-item" key={`url-value-${index}`}>
          {this.renderTypeComponent(entry, index)}
          {index > 0 && 
            <div className="url-filter-multi-entry-remove" onClick={() => this.removeEntryFromUrlValue(index)} >
              <Icon name="close" height={12} width={12} />
            </div>
            }
        </div>
      ))
    return entries
  }

  render() {
    return (
      <div className="rules-choice rules-url-filter">
        <header>
          <h1>Choose a URL</h1>
          <p>Match on a number of URL parameters such as, Path, Host, and Query Param </p>
        </header>
        <div className="url-rules-editor-container">
          <div className="url-rules-editor-item">
            { this.renderTypeSelect() }
          </div>
          <div className="url-rules-editor-item">
            { this.renderOperatorType() }
          </div>
          <div className="url-rules-editor-item">
            {this.renderMultiEntryInputs()}
            <div>
              <Button className="url-filter-multi-entry-add" size="small" type="subtle" onClick={this.addEntryToUrlValue}>+</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UrlFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/UrlFilter/index.js